import { Navigate, useOutletContext } from "react-router-dom";
import MakerStatus from "./status/MakerStatus";
import { useSelector } from "react-redux";

const MakerReferred = () => {
  const ref = useOutletContext();
  const userRole = useSelector(
    (state) => state?.userAuth?.data?.role
  )?.toLowerCase();
  return userRole === "maker" ? (
    <MakerStatus anchor={ref} status="referred" title="Referred Merchants" />
  ) : (
    <Navigate to="/not-found" replace />
  );
};

export default MakerReferred;
